import {Component, output} from '@angular/core';
import {PollTypeEnum} from "../../../../utils/enums/poll-type.enum";

@Component({
  selector: 'app-poll-start',
  standalone: true,
  imports: [],
  templateUrl: './poll-start.component.html',
  styleUrl: './poll-start.component.scss'
})
export class PollStartComponent {
  typeSelected = output<PollTypeEnum>();
  readonly pollTypeEnum = PollTypeEnum;

  selectType(type: PollTypeEnum) {
    this.typeSelected.emit(type);
  }

}
